
import {useState,useEffect} from 'react'
import {useNavigate , useLocation} from "react-router-dom";
import SendData from "./SendData"
import Switch from "./components/Switch"

function Modal ({titr,items,onChange,onClose}){
  return (
    <div className="modal"  /*style={overlayerStyle}*/>
      <h2 style={{textAlign:'center'}} >
        {titr}
      </h2>
      {items}
    </div>
  );
}

const overlayerStyle = {
  position:'fixed',
  top:0,
  left:0,
  right:0,
  bottom:0,
  background: "rgba (0,0,0,0,5)",
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  zIndex:1000
};

const modalStyle = {
  background: '#fff',
  padding:20,
  borderRadius:8,
  width:'80%',
  maxWidth:300
};

function MandatorySetting ({socket}){
  const location = useLocation ();
  const [name,setName] = useState (/*location.state.name*/);
  const navigate = useNavigate ();

  const [time_close,setTime_close]=useState (location.state.time_close+'');
  const [time_open,setTime_open]=useState (location.state.time_open+'');
  const [darsad,setDarsad]=useState (location.state.darsad+'');

  const [mode,setMode] = useState (false);

  const [modalShow_delete,setModalShow_delete] = useState (false);
  const [modalShow,setModalShow] = useState (false);
  const [times,setTimes] = useState ([{name:"روز",time_start:{hor:10,min:22},long:5,darsad:20},{name:"شب",time_start:{hor:22,min:22},long:1,darsad:5}]);
  const [name_time,setName_time] = useState ();
  const [hor_time,setHor_time] = useState ();
  const [min_time,setMin_time] = useState ();
  const [long_time,setLong_time] = useState ();
  const [darsad_time,setDarsad_time] = useState ();

  const [select,setSelect] = useState (-1);

  useEffect (()=>{
    if (location.state.time!=null)
      setTimes (location.state.time);
    else {
      setTimes([]);
      }
  return () =>{
    socket.off ('message');
  };
},[socket]);

  return (
    <div style={style.container}>
    {
      modalShow_delete && (
    <Modal
      titr={"میخواهید هوا دهی"+'  '+times[select].name+'  '+'را حذف نمایید'}
      items={
        <div>
          <div style={{flex:1}}  className="row"  >
          <button   className='btn'
            onClick={()=>{
              var a=times; a.splice(select, 1); setTimes (a); setSelect (-1);
              setModalShow_delete (false)
            }} >
            بله
          </button>
          <button   className='btn'
            onClick={()=>{
              setModalShow_delete (false)
            }} >
            خیر
          </button>
          </div>

          </div>
      }

     /> )}

     {
       modalShow && (
     <Modal
       titr="تنظیم هوا دهی در زمان مشخص"
       items={
         <div >

         <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row'  }}>
         <input style={{width:"90%",flex:.74,maxWidth:420, padding:14, fontSize:20,borderRadius:8,textAlign:"center"}}
         type="text"
         placeholder = ""
         value={name_time}
         onChange = {(e)=>{setName_time (e.target.value)}}/>
         <h2 style={{ fontSize:20 , alignSelf:'center' ,margin:10 }} >نام هوا دهی</h2>
         </div>

         <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row'  }}>
         <input style={{width:"90%",flex:.3,maxWidth:420, padding:14, fontSize:20,borderRadius:8,textAlign:"center"}}
         type="tel"
         placeholder = ""
         value={hor_time}
         onChange = {(e)=>{setHor_time (e.target.value)}}/>
         <h2 style={{ fontSize:20 , alignSelf:'center' ,margin:10 }} >: </h2>

         <input style={{width:"90%",flex:.3,maxWidth:420, padding:14, fontSize:20,borderRadius:8,textAlign:"center"}}
         type="tel"
         placeholder = ""
         value={min_time}
         onChange = {(e)=>{setMin_time (e.target.value)}}/>
         <h2 style={{ fontSize:20 , alignSelf:'center' ,margin:10 }} >زمان شروع </h2>
         </div>

         <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row'  }}>
         <input style={{width:"90%",flex:.74,maxWidth:420, padding:14, fontSize:20,borderRadius:8,textAlign:"center"}}
         type="tel"
         placeholder = ""
         value={long_time}
         onChange = {(e)=>{setLong_time (e.target.value)}}/>
         <h2 style={{ fontSize:20 , alignSelf:'center' ,margin:10 }} >مدت هوا دهی</h2>
         </div>


         <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row'  }}>
         <input style={{width:"90%",flex:.74,maxWidth:420, padding:14, fontSize:20,borderRadius:8,textAlign:"center"}}
         type="tel"
         placeholder = ""
         value={darsad_time}
         onChange = {(e)=>{setDarsad_time (e.target.value)}}/>
         <h2 style={{ fontSize:20 , alignSelf:'center' ,margin:10 }} >درصد باز شدن</h2>
         </div>
           <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row'  }}>

           <div  style={{ margin:10  ,flex:.5 }}>
           <button className='btn'
              onClick={() => {
                {
                  var a={name:name_time,time_start:{hor:hor_time,min:min_time},long:long_time,darsad:darsad_time};
                  var b=times;
                  if (select>=0)
                  {
                    b[select]=a;
                    setTimes (b);
                  }else {
                    b.push (a);
                    setTimes (b);
                  }
                  setModalShow (false);
               }
              }}
              >
              تایید
              </button>
            </div>
            <div  style={{ margin:10  ,flex:.5 }}>
            <button className='btn' style={{fontSize:20,flex:.4,margin:10}}
                 onClick={() => { setModalShow (false); }}
              >
              کنسل
              </button>
              </div>
           </div>
         </div>
       }
      /> )}

       <div style={style.content}>
         <h2 style={style.text}>
           تنظیم هوا دهی در زمان مشخص
         </h2>
       <div style={{backgroundColor:'white',padding:10}}>

       {

         times.map( (value,key) => {
            return (
              <div  key={key} style={{borderRadius:10, backgroundColor:(select==key)?'#09f':'#00f0',justifyContent: 'space-between', flex:1, padding:5 ,flexDirection:'row' }}
                onClick={()=>{
                  setSelect (key);
                }}
              >
              <h2 style={{color:(select==key)?'white':'#09f', fontSize:20,flex:.5, fontStyle: "italic",textAlign:"center" }}>
              {value.name+ " در ساعت: "+value.time_start.hor+':'+value.time_start.min}
              </h2>
              <h2 style={{color:(select==key)?'white':'#09f', fontSize:20,flex:.5, fontStyle: "italic",textAlign:"center" }}>
              {"به مدت :"+value.long+" دقیقه " + " , "+ value.darsad + " درصد "}
              </h2>

              </div>
            )

          })
        }
        </div>
        </div>


        <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row' ,flex:1 }}>
        <div  style={{ margin:10  ,flex:1/3 }}>
        <button className="btn"
           title="افزودن"
           onClick={() => {

             if (times.length>=5) window.alert ('امکان افزایش شماره وجود ندارد');
             else {

               setSelect (-1);
               setName_time ('');
               setHor_time (1);
               setMin_time (0);
               setLong_time (1);
               setDarsad_time (10);
               setModalShow (true);
            }
          }}
           >
           افزودن
           </button>
         </div>
         <div  style={{ margin:10  ,flex:1/3 }}>
         <button className="btn" style={{fontSize:20,flex:.4,margin:10}}
              title="ویرایش"
              onClick={() => {
                if (select>=0){
                  setName_time (times[select].name);
                  setHor_time (times[select].time_start.hor);
                  setMin_time (times[select].time_start.min);
                  setLong_time (times[select].long);
                  setDarsad_time (times[select].darsad);
                  setModalShow (true);
              }}}
           >
           ویرایش
           </button>
           </div>
           <div  style={{ margin:10  ,flex:1/3  }}>
         <button className="btn" style={{fontSize:20,flex:.2,margin:10}}
                 title="حذف"
                 onClick={() => {
                   if (select>=0)
                     setModalShow_delete (true);
                 }}
           >
           حذف
           </button>
           </div>
       </div>

       <div >

       <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row' ,flex:1 }}>
        <h2 style={{ fontSize:18 , alignSelf:'center' ,textAlign:'right' ,margin:10 ,flex:.7 }}>
        مدت بسته بودن پنجره برای هوا دهی
        </h2>
        <input style={{width:"90%",flex:.3,maxWidth:420, padding:10,margin:0, fontSize:20,borderRadius:8,textAlign:"center"}}
        type="tel"
        placeholder = ""
        value={time_close}
        onChange = {(e)=>{setTime_close (e.target.value)}}/>
        </div>




        <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row' ,flex:1 }}>
        <h2 style={{ fontSize:20 , alignSelf:'center' ,textAlign:'right' ,margin:10 ,flex:.7 }}>
      مدت هوا دهی اجباری
      </h2>
      <input style={{width:"90%",flex:.3,maxWidth:420, padding:10,margin:0, fontSize:20,borderRadius:8,textAlign:"center"}}
      type="tel"
      placeholder = ""
      value={time_open}
      onChange = {(e)=>{setTime_open (e.target.value)}}/>
  </div>

  <div  className='row' style={{ borderRadius:4 , margin:10  ,flexDirection:'row' ,flex:1 }}>
  <h2 style={{ fontSize:20 , alignSelf:'center',textAlign:'right' ,margin:10 ,flex:.7 }}>
    درصد باز شدن پنجره
    </h2>
    <input style={{width:"90%",flex:.3,maxWidth:420, padding:10,margin:0, fontSize:20,borderRadius:8,textAlign:"center"}}
    type="tel"
    placeholder = ""
    value={darsad}
    onChange = {(e)=>{setDarsad (e.target.value)}}/>
  </div>
  </div>

  <button className="btn"
      onClick ={()=>{
      socket.off ('message');
      socket.on ('message',(data)=>{
            if (JSON.parse(data).event=="SAVE_MENU_MANDATORY" && JSON.parse(data).data==true)
            {
              window.alert ('اطلاعات با موفقیت ذخیره شد');
              socket.off ('message');
              navigate (-1);
            }
        });

        SendData (socket,'data',{
          "event":"set_menu_mandatory",
          "data":{
            "time_close":time_close,
            "time_open":time_open,
            "darsad":darsad,
            "times":times,
          }
        });
      }}>
       تایید
    </button>
    </div>
  );


}
const style={
  container:{
    width:"90%",
    minHeight:"100vh",
//    display:"flex",
    alignItems:"center",
    padding:10,

//    backgroundColor:"#00f7f7"
  },
  content:{

    width:"100%",
     maxWidth:820,
    display:"flex",
    flexDirection:"column",
    gap:12,
    marginTop:10,
    padding:10,
    backgroundColor:"#00afff",
    borderRadius:8
  },
  input:{
    width:"90%",
    maxWidth:420,
    padding:14,
    fontSize:20,
    borderRadius:8,
    textAlign:"center"
//    border:"1px solid #ccc"
  },
  button:{
    width:"100%",
    maxWidth:820,
    padding:4,
    fontSize:16,
    borderRadius:8,
    border:"nune",
    backgroundColor:"#1976d2",
    coloe:"#fff",
    cursor:"pointer"
  },
  text:{
    alignItems:"center",
    textAlign:"center",
    width:"90%",
    padding:14,
    fontSize:24,
    borderRadius:8,
    border:"nune",
    padding:0,
    margin:10,
  //  backgroundColor:"#1976d2",
    coloe:"#fff",
//    cursor:"pointer"
  }

}

export default MandatorySetting;
